import { Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { TabBar } from "./TabBar";
import { Sidebar } from "./Sidebar";
import { ErrorBoundary } from "@/components/error-boundary";
import { ConfigDriftBanner } from "@/components/config-drift-banner";

const fullHeightRoutes = new Set(["/admin/logs", "/admin/ami-console"]);
// Routes that span the full viewport width instead of the centered reading column
const fluidRoutes = new Set(["/"]);

export function MainLayout() {
  const location = useLocation();
  const isFullHeight = fullHeightRoutes.has(location.pathname);

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <TabBar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main
          className={cn(
            "flex-1 scrollbar-thin",
            isFullHeight ? "overflow-hidden" : "overflow-y-auto"
          )}
        >
          <div
            key={location.pathname}
            className={cn(
              "animate-page-in",
              isFullHeight
                ? "flex h-full min-h-0 flex-col"
                : fluidRoutes.has(location.pathname)
                  ? "w-full p-8"
                  : "mx-auto w-full max-w-[1440px] p-6"
            )}
          >
            <ConfigDriftBanner />
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
}
